import { Dispatch, SetStateAction } from "react";

import { Box } from "@mui/material";
import RenderImagesByBase64 from "@app/components/RenderImagesByBase64";

import { ImagesWrapper } from './styled';

interface RenderNewUploadingImagesListProps<T> {
  togetherImagesLength: number;
  newPreviewsList: string[] | [];
  setState: Dispatch<SetStateAction<T>>;
}

const RenderNewUploadingImagesList = <T, >({
  newPreviewsList,
  togetherImagesLength,
  setState,
}:RenderNewUploadingImagesListProps<T>) => {
  if (!newPreviewsList.length) {
    return null
  }

  return (
    <Box sx={{ mb: 2 }}>
      <ImagesWrapper>
        {
          newPreviewsList.map((src) => {
            return (
              <RenderImagesByBase64<T>
                key={src}
                src={src}
                togetherImagesLength={togetherImagesLength}
                setState={setState}
              />
            )
          })
        }
      </ImagesWrapper>
    </Box>
  );
}

export default RenderNewUploadingImagesList;
